import React from 'react';

const classnames = {
  mercury: 'text-14 leading-normal text-white',
  venus:
    'text-14 leading-normal text-blue underline hover:no-underline cursor-pointer',
  earth: 'text-14 leading-normal',
  mars: 'text-16 leading-normal font-medium',
  jupiter: 'text-14 leading-normal text-grey-darkest',
  saturn: 'text-14 leading-normal text-pink',
  uranus: 'text-12 leading-normal text-grey-darkest',
  neptune: 'text-16 leading-normal',
};

function Text({children, ui = 'earth', ...restProps}) {
  return (
    <div className={classnames[ui]} {...restProps}>
      {children}
    </div>
  );
}

export default Text;
